<div>
    <h3>¿Por qué red recibir {{system.attributes.name}} en Saldoar?</h3>
    <p class="text-section">Aquí podrás ver las diferentes redes que puedes elegir para recibir tus {{system.attributes.name}}, junto con el costo de transacción de cada una.</p>
    <app-slide [elementWidth]="369" [margin]="24" [elementQty]="system.relationships.networks.data.length" *ngIf="system.relationships.networks.data.length !== 0">
        <ng-container>
            <mat-card *ngFor="let network of system.relationships.networks.data">
                <mat-card-content>
                    <div class="icon-container">
                        <app-system-icon [systemId]="system.id" [alt]="system.attributes.name" [title]="system.attributes.name" width="43.5" height="43.5"></app-system-icon>
                        <img src="../../../../assets/images/networks/{{network.id}}.png" alt="{{network.attributes.title}}" title="{{network.attributes.title}}" class="network-image" width="21.43" height="21.43">
                    </div>
                    <div class="info-container">
                        <h5>Red: {{network.attributes.title}}</h5>
                        <span>fee: {{network.attributes.fixed_fee_usd}} {{system.attributes.currency}}</span>
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-container>
    </app-slide>
</div>
